import styled from "styled-components";

import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { rawColors } from "../../../design-system/tokens/colors";
import { KG_DATA_SOURCE_TEXT_STACK_GAP_PX } from "../../kg/kgNodeDimensions";
import {
  kgNodeEllipsisTextCenterStyles,
  kgNodeTextContainerStyles,
} from "../../kg/kgNodeText.styles";

/** Outer vertical stack: DB icon → logo+name row → subtitle (Figma gap: 12px). */
export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${spacing[3]};
  ${kgNodeTextContainerStyles}
`;

/** Logo row + subtitle (Figma gap: 2px). */
export const TextStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${KG_DATA_SOURCE_TEXT_STACK_GAP_PX}px;
  ${kgNodeTextContainerStyles}
`;

/** Horizontal row: connector logo + connector name (Figma gap: 4px). */
export const LogoRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: ${spacing[1]};
  ${kgNodeTextContainerStyles}
`;

export const Title = styled.span`
  ${typographyMixin("caption", 3)}
  color: ${rawColors.grey[800]};
  ${kgNodeEllipsisTextCenterStyles}
  flex: 1;
  min-width: 0;
`;

export const Subtitle = styled.span`
  ${typographyMixin("overline", 4)}
  color: ${rawColors.grey[600]};
  ${kgNodeEllipsisTextCenterStyles}
`;
